import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { url } from "../config";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    // State to hold the authentication token
    const [token, setToken_] = useState();
    const [logged, setLogged] = useState(false);

    // Function to set the authentication token
    const setToken = (newToken) => {
        setToken_(newToken);
        if (newToken == null) {
            localStorage.removeItem("limelight_partners_admin_token");
        } else {
            localStorage.setItem("limelight_partners_admin_token", newToken);
        }
    };

    async function login(email, password) {
        console.log("LOGIN");
        console.log(email);
        console.log(password);
        setLoading(true);

        try { 
            var { data } = await axios.post(`${url}/api`,
                {
                    "UserLoginId": email,
                    "UserPwd": password,
                    "url" : "getLoginDetails"
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    },
                }
            ); 
            console.log(data);
            if(data.length === 0){
                return "err";
            }
            setLogged(true);
            setToken(data[0]);
            setLoading(false);
            // console.log(data.token);
            setUser(data[0]);
            localStorage.setItem("user", JSON.stringify(data.user));
            console.log(user);
            // console.log(data.user);
        } catch (error) {
            return "err";
        }
    }


    // Call the logout endpoint and then remove the user
    // from the state.
    function logout() {
        setLogged(false);
        setLoading(false);
        setToken(null);
        // sessionsApi.logout().then(() => setUser(undefined));
    }

    useEffect(() => {

        let tkn = localStorage.getItem("user");
        console.log(tkn);
        console.log(typeof tkn);

        if (tkn !== null && tkn !== "null" && tkn !== "undefined") {
            setLogged(true);
            setLoading(false);
            setToken(tkn);

            // set user too
            setUser(JSON.parse(localStorage.getItem("user")));
        } else {
            setLogged(false);
            setLoading(false);
            setToken(null);
        }

        if (tkn) {
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            // localStorage.setItem('token', token);
        } else {
            // delete axios.defaults.headers.common["Authorization"];
            // localStorage.removeItem('token')
        }

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Memoized value of the authentication context
    const contextValue = useMemo(
        () => ({
            loading,
            logged,
            token,
            user,
            login,
            setToken,
            logout,
        }),
        [token, logged] // eslint-disable-line react-hooks/exhaustive-deps
    );

    // Provide the authentication context to the children components
    return (
        <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export default AuthProvider;